/** 优惠券类型 */
export enum CouponType {
  /** 默认(带prize logo券) */
  default = 'default',
  /** 现金券 */
  cash = 'cash',
  /** 折扣券 */
  discount = 'discount',
  /** 连锁券 */
  // chain = 'chain',
}

/** 优惠券按钮类型 */
export enum CouponButtonType {
  /** 默认 (按钮背景为主题色) */
  default = 'default',
  /** 弱化 (按钮为白色，字为主题色) */
  weaken = 'weaken',
  /** 置灰 */
  disabled = 'disabled',
  /** 锁住 (带上锁图标) */
  lock = 'lock',
}

/** 标签类型 */
export enum CouponTagColor {
  /** 橙色 */
  orange = 'orange',
  /** 红色 */
  red = 'red',
}

/** 主题色枚举 */
export enum ThemeColor {
  /** 绿色 */
  green = 'green',
  /** 橙色 */
  orange = 'orange',
  /** 红色 */
  red = 'red',
  /** 白色 */
  white = 'white',
}

/** 金额与折扣字号枚举 */
export enum NumberFontSize {
  /** 小号 */
  s = 's',
  /** 加小号 */
  xs = 'xs',
}

/** 优惠券提示条类型 */
export enum CouponTipsType {
  /** 手动 */
  manual = 'manual',
  /** 连锁 */
  chain = 'chain',
  /** 银行专属 */
  bank = 'bank',
}


/**
 * 优惠券信息
 */
export type CouponInfo =  {
  /* 优惠券类型 */
  couponType?: CouponType,
  /* 优惠券奖品logo */
  prizeLogo?: string,
  /* 优惠券名称 */
  prizeName: string,
  /* 优惠券描述 */
  prizeDesc: string,
  /* 商户描述 */
  spDesc?: string,
  /* 商户图标 */
  spLogo?: string,
  /* 优惠券标签文本 */
  couponTagText?: string,
  /* 优惠券标签颜色 */
  couponTagColor?: CouponTagColor,
  /* 按钮文本 */
  couponBtnText?: string,
  /* 按钮类型 */
  buttonType?: CouponButtonType,
  /* 邮戳文本 */
  stampText?: string,
  /* 优惠券优惠面额（元） */
  prizeAmountYuan: number,
  /* 优惠券折扣（折） */
  prizeDiscount: number,
  /* 优惠券主题色 */
  themeColor?: string,
  /** 是否连锁券 */
  isChain?: boolean,
  /* 优惠券是否已过期（过期时会将券背景设置为灰色，同时按钮置灰，以及加上邮戳，因此需要设置邮戳文本） */
  isExpire?: boolean,
  /* 是否展示按钮 */
  isShowButton?: boolean,
  /* 是否展示邮戳 */
  isShowStamp?: boolean,
  /* 是否展示层叠阴影 */
  isShowShadow?: boolean,
  /* 优惠券提示条文本 */
  tipsText?: string,
  /* 优惠券提示条文本 - 右侧 */
  tipsTextRight?: string,
  /* 优惠券提示条类型 */
  tipsType?: CouponTipsType,
  /* 优惠券挖空半圆颜色 */
  semicircleColor?: string,
};
